var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.external ? 'a' : 'nuxt-link',{tag:"component",staticClass:"csLink",attrs:{"to":_vm.href,"href":_vm.href},on:{"click":function (e) { return _vm.$emit('click', e); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }